/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TaggedUntaggedResourcesByProductCategory {
    getFixupPrototypeFunction() { return TaggedUntaggedResourcesByProductCategory.fixupPrototype; }

    static newInstance(model: Partial<TaggedUntaggedResourcesByProductCategory>): TaggedUntaggedResourcesByProductCategory {
        let obj = Object.assign(new TaggedUntaggedResourcesByProductCategory(), model);
        TaggedUntaggedResourcesByProductCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TaggedUntaggedResourcesByProductCategory>): TaggedUntaggedResourcesByProductCategory {
        if (!model) return null;
        return TaggedUntaggedResourcesByProductCategory.newInstance(<TaggedUntaggedResourcesByProductCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TaggedUntaggedResourcesByProductCategory) {
        if (!obj) return;

        models.TaggedUntaggedResourcesByProductCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TaggedUntaggedResourcesByProductCategory): boolean {
        Object.setPrototypeOf(obj, TaggedUntaggedResourcesByProductCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.untagged_resources === undefined) {
            this.untagged_resources = 0;
        }
        if (this.tagged_resources === undefined) {
            this.tagged_resources = 0;
        }
    }

    /**
     * Cost for all untagged resources in category
     */
    untagged_resources: number;

    /**
     * Cost for all tagged resources in category
     */
    tagged_resources: number;

    /**
     * product category type
     */
    product_category: string;

}
